module.exports = __webpack_public_path__ + "media/images/pic/popup/popup-mobile-icons-bcad6d0999f4491aab659da0b5b3e6e4.jpg";